import { Routes } from '@angular/router';

/**
 * App page slot. An app (ISPB, BRD, OKS, Galis) can ship its own Angular pages under /cms
 * without touching core: the build replaces this folder with the module's Client/Project
 * (developer machine: junction Client/Project -> src/app/project). Core ships it empty.
 * Pages must be standalone components; import core services by 'src/app/...' paths.
 */
export const PROJECT_ROUTES: Routes = [];
